import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {GotchaMainResponseVo} from '../../common/shared/api/nicolas/vo/GotchaMainResponseVo.interface';
import type {Maybe} from '../../graphql/generated/types';

export type GetGotchaParams = {
  gotchaId: string;
  adLocId?: Maybe<string>;
};

/**
 * 갓챠 정보 조회 (v2)
 *
 * Origin: pageNicolasApi.getGotcha
 * API: POST /api/v2/gotcha
 */
export async function postGotchaGet(
  {gotchaId, adLocId}: GetGotchaParams,
  options?: FetcherOptions
): Promise<
  ApiResultVo & {
    gotcha_id: string;
    gotcha_info: GotchaMainResponseVo;
  }
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/gotcha',
    {
      method: 'POST',
      data: {
        gotcha_id: gotchaId,
        ...(adLocId && {ad_loc_id: adLocId}),
      },
    },
    options
  );
  return response.data;
}
